import React from 'react'
import { BaseComponent } from 'belle-js'

const withFormResponseHandler = (FormComponent) => {
  class FormResponseHandler extends BaseComponent {

    componentWillReceiveProps (nextProps) {
      if (this.props.isSubmitting && !nextProps.isSubmitting) {
        // Respond to BelleForm events here
        if (nextProps.submitSucceeded) {
          // On Success
          this.handleSuccess(nextProps.responseData)
        } else if (nextProps.submitFailed) {
          // On Failure
          this.handleFailure(nextProps.responseErrors)
        }
      }
    }

    handleFailure (errors) {
      this.props.failureHandler(errors)
    }

    handleSuccess (data) {
      this.props.successHandler(data)
    }

    render () {
      return <FormComponent {...this.props} />
    }

  }

  return FormResponseHandler
}
export default withFormResponseHandler



// WEBPACK FOOTER //
// ./src/components/Onboarding/withFormResponseHandler.jsx